import { isEmpty } from 'lodash';
import { ScheduleSettingsErrorMessage } from '../../utils/constants';

function shouldShowOneOrMoreCategoryError ({ display, type }) {
  if (!isEmpty(type) && type === 'eventV2') {
    if (display?.scheduleOption === 2 || display?.scheduleOption === '2') {
      if ((isEmpty(display?.categoryInfo) || display?.categoryInfo?.length <= 0)) {
        return true;
      }

      return false;
    }
  }

    if (display?.scheduleOption === 2 || display?.scheduleOption === '2') {
      if ((isEmpty(display?.categories) || display?.categories?.length <= 0)) {
        return true;
      }
    }

    return false;
}

function shouldShowOneOrMoreScheduleError ({ display }) {
    if ((display?.scheduleOption === 3 || display?.scheduleOption === '3') &&
    (isEmpty(display?.schedules) || display?.schedules?.length <= 0)) {
        return true;
    }
    return false;
}

function validateScheduleByCategory ({ display, type }) {
    if (shouldShowOneOrMoreCategoryError({ display, type })) {
      return {
        title: ScheduleSettingsErrorMessage.selectCategory.title,
        message: ScheduleSettingsErrorMessage.selectCategory.message,
      };
    }
    return null;
}

function validateScheduleBySelection ({ display }) {
  if (shouldShowOneOrMoreScheduleError({ display })) {
    return {
      title: ScheduleSettingsErrorMessage.selectSchedule.title,
      message: ScheduleSettingsErrorMessage.selectSchedule.message,
    };
  }
  return null;
}

function validateScheduleOptions ({ display, type }) {
  const categoryError = validateScheduleByCategory({ display, type });
  if (categoryError) return categoryError;

  const scheduleError = validateScheduleBySelection({ display });
  if (scheduleError) return scheduleError;

  return null;
}

function useScheduleValidation (setInputErrors) {
    function validateUpsertRule (savable, showDialog = false) {
        const error = validateScheduleOptions({ display: savable?.display, type: savable?.type });
        if (error) {
            if (showDialog && setInputErrors && setInputErrors.toString() !== '() => {}') {
                setInputErrors(error);
            }
            return false;
        }

        return true;
    }

  return {
    validateUpsertRule,
  };
}

export default useScheduleValidation;
